import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { ThemeProvider, Button } from '@workboard/wobo-ui';
import { Add } from '@material-ui/icons';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ReadOnlyComp } from '../../read-license/index';
import { Popover } from '@workboard/wobo-ui';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  h1 {
    margin: 0;
    font-size: 1.5rem;
    line-height: 2.5rem;
    font-weight: bold;
  }
`;

function Header(readOnly,{ boardModule }) {
  const { t } = useTranslation();
  const anchor = useRef();
  const [open, setOpen] = useState(false);
  const [isRead, setIsRead] = useState(false);
  const [rolEvent, setRolEvent] = useState(null);
  const readFlag = readOnly.readOnly.readFlag;
  const isUserReadOnly = readOnly.readOnly.isUserReadOnly;
  const page = new URL(window.location.href).pathname;
  const handleAddWorkstream = () => {
    if (readFlag && isUserReadOnly) {
      setIsRead(true)
      setRolEvent({
        rolEventTarget: "Add Workstream",
        rolEventType: "Click",
        rolEventSource: page
      })
    } else {
      // parameters were used only inside workstream
      $.post(addWorksream, {teamId: '', columnId: 0}, function (data) {
        openCreateWsDialog(data);
      });
      setOpen(!open);
    }
  }

  const handleAddVisualBoard = () => {
    if (readFlag && isUserReadOnly) {
      setIsRead(true);
      setRolEvent({
        rolEventTarget: "Add Visual Board",
        rolEventType: "Click",
        rolEventSource: page
      })
    } else {
      openCreateBoardPopUp('createBoard', boardModule);
      setOpen(!open);
    }
  }

  const handleButtonClose = async () => {
    setIsRead(false);
    setRolEvent(null);
  }
  if (hasLayout) return <></>;

  return (
    <ThemeProvider>
      <Wrapper>
        <h1>{t('Workstreams')}</h1>
        {
          readFlag && isUserReadOnly ?
          <div>
            <Button
              variant="secondary"
              size="large"
              ref={anchor}
              startIcon={<Add />}
              style={{ marginRight: 20,
                      color : readFlag && isUserReadOnly ? '#b7d6e5' : '#0072ab',
                      border : readFlag && isUserReadOnly ? '1px solid #b7d6e5' : '1px solid #0072ab',
                      backgroundColor : '#ffffff' }}
              onClick={handleAddVisualBoard}
            >
              {t('New Visual Board')}
            </Button>
            <Button
              variant="primary"
              size="large"
              ref={anchor}
              startIcon={<Add />}
              onClick={handleAddWorkstream}
              style={{backgroundColor: '#b7d6e5', color: '#ffffff'}}
            >
              {t('New Workstream')}
            </Button>
            {
              isRead && (
                <Popover
                  targetRef={anchor}
                  removeActions
                  removeClose
                  arrow={false}
                  placement="bottom-start"
                  open={isRead}
                  onDismiss={() => setIsRead(false)}
                  className="readOnlyOver"
                  content={
                    <ReadOnlyComp
                        handleClose={handleButtonClose}
                        rolEvent={rolEvent}
                    />
                  }
                />
              )
            }
          </div>
        :
        <div>
          <Button
              variant="primary"
              size="large"
              ref={anchor}
              startIcon={<Add />}
              onClick={handleAddVisualBoard}
              style={{ marginRight: 20,
                color : readOnly ? '#0072ab' : '#b7d6e5',
                border : readOnly ? '1px solid #0072ab' : '1px solid #b7d6e5' ,
                backgroundColor : '#ffffff' }}
          >
            {t('Add Visual Board')}
          </Button>
          <Button
              variant="primary"
              size="large"
              ref={anchor}
              startIcon={<Add />}
              onClick={handleAddWorkstream}
          >
            {t('New Workstream')}
          </Button>
        </div>
        }
      </Wrapper>
    </ThemeProvider>
  );
}

export default connect(state => ({ boardModule: state.boardModule }))(Header);
